import i18n, { type InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";

if (!i18n.isInitialized) {
  const options: InitOptions = {
    resources,
    lng: "ja",
    fallbackLng: "ja",
    defaultNS: "console",
    ns: ["console"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    initAsync: false,
  };

  i18n.use(initReactI18next);
  void i18n.init(options);
}

export { i18n };
